import api from '../api'

const baseUrl = '/academy/api/AdminStudent'

const dadbanStudentProvider = {
  getAllStudents(params = {}) {
    return api.post(`${baseUrl}/Table`, {
      params,
    })
  },

  getStudent(id) {
    return api.get(`${baseUrl}/Get/${id}`)
  },

  addStudent(params) {
    return api.post(`${baseUrl}/Add`, params)
  },

  updateStudent(params = {}) {
    return api.put(`${baseUrl}/Edit`, params)
  },

  deleteStudent(params) {
    return api.delete(`${baseUrl}/Delete/${params}`)
  },
}

export default dadbanStudentProvider
